import { Classes, Dialog } from "@blueprintjs/core";
import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { ExperienceProfessionnelleApi, ExperienceProfessionnelleFichierDto } from "../../../../../../api";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { useReferential } from "../../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../../locales";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface IExperienceProfessionnelleDocumentEditDialogProps {
  idexperienceProfessionnelleFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const ExperienceProfessionnelleDocumentEditDialog: React.FunctionComponent<IExperienceProfessionnelleDocumentEditDialogProps> = ({
  idexperienceProfessionnelleFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(ExperienceProfessionnelleApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.experienceProfessionnelleGetExperienceProfessionnelleFichier({
            id: idexperienceProfessionnelleFichier
          });
        },
        saveApiFn: async (d: ExperienceProfessionnelleFichierDto) => {
          return api.experienceProfessionnelleSaveExperienceProfessionnelleFichier({
            ExperienceProfessionnelleFichierDto: d
          });
        },
        onSaved: () => onClose(true)
      }),
      [api, idexperienceProfessionnelleFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeAcquisFichier: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  const [typesAcquisFichier, tLoading] = useReferential(a => a.referentialGetTypesAcquisFichier());

  return (
    <StyledDialog
      title={t(ETLCodes.UploadFichier)}
      isOpen={!!idexperienceProfessionnelleFichier}
      onClose={() => onClose(false)}
    >
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeAcquisFichier"
              label={t(ETLCodes.Type)}
              items={typesAcquisFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
